import type { ReactNode } from 'react';
import styles from './GlobalAlertsContent.module.scss';

interface Props {
  messages: ReactNode[];
}

export const GlobalAlertsContent = ({ messages }: Props) => {
  return (
    <div className={styles.container}>
      {messages.map((message, index) => (
        <div className={styles.message} key={index}>
          {message}
        </div>
      ))}
    </div>
  );
};